export function usePage() {
	const body = document.body;

	const setSubExpired = (state: boolean): void => {
		if (state) {
			body.classList.add('is-expired');
		} else {
			body.classList.remove('is-expired');
		}
	};

	return {
		setSubExpired: setSubExpired
	};
}
